<template>
	<AppContentLayout class="settings-page">
		<v-row no-gutters class="fill-height px-6">
			<v-col cols="3" style="position: relative">
				<v-row no-gutters>
					<SettingsTabs />
				</v-row>
			</v-col>

			<v-col cols="9" class="pl-10" style="position: relative">
				<div class="crd_wrp">
					<div class="white pa-4 elevation-0 set_card">
						<v-row no-gutters>
							<v-col cols="6">
								<v-fade-transition>
									<router-view />
								</v-fade-transition>
							</v-col>
						</v-row>
					</div>
				</div>
			</v-col>
		</v-row>
	</AppContentLayout>
</template>

<script>
// Todo: This component needs to be completely refactor in the sense of it's layout and it's subcomponents layout
// Braindump:
// subcompopnents should have a <SubContentLayout> components handling it's transitions and layout
import AppContentLayout from '../AppLayout/AppContentLayout';

import SettingsTabs from '@/components/Settings/SettingsTabs';

export default {
	name: 'Settings',
	components: {
		AppContentLayout,
		SettingsTabs,
	},
	computed: {},
	methods: {},
	data: () => ({}),
};
</script>

<style scoped lang="scss">
.settings-page {
	height: 90vh;
}
h5 {
	font-size: 12px;
}
.set_card {
	border-radius: 7px !important;
	border: 1px solid #eff1f8 !important;
	height: 80%;
	overflow-y: auto;
	position: relative;
}
.dev {
	color: #eff1f8 !important;
	border-color: #eff1f8 !important;
	background-color: #eff1f8 !important;
}
.v-list-item--active {
	background: transparent;
	color: #1473e6;
}
.v-list-item__subtitle {
	color: inherit !important;
}
.crd_wrp {
	position: absolute;
	top: 42px;
	bottom: 30px;
	left: 30px;
	right: 0px;
}
::v-deep {
	.v-data-table__wrapper {
		overflow: auto;
		max-height: 500px;
	}
}
</style>
